nativeRegExpMethod